import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../data/site";

export const Navbar = ({ onQuoteClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled;

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent border-b border-transparent"
          : "bg-white/90 backdrop-blur-xl border-b border-slate-200"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/logo.png"
            alt="IDEAL ENTERPRISES"
            className="h-12 md:h-14 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium transition-colors ${
                  transparent
                    ? "text-white/85 hover:text-white"
                    : isActive
                    ? "text-brand-orange"
                    : "text-slate-700 hover:text-brand-blue"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="navbar-quote-btn"
            onClick={onQuoteClick}
            className="hidden md:inline-flex items-center gap-2 bg-brand-orange text-white px-5 py-2.5 text-sm font-semibold btn-lift hover:bg-orange-600"
          >
            Request a Quote
          </button>
          <button
            className={`lg:hidden p-2 ${transparent ? "text-white" : "text-brand-blue"}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="navbar-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${
                    isActive ? "text-brand-orange" : "text-slate-700"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <button
              data-testid="mobile-quote-btn"
              onClick={onQuoteClick}
              className="mt-3 bg-brand-orange text-white py-3 text-sm font-semibold"
            >
              Request a Quote
            </button>
            <a
              href={`tel:${COMPANY.phone}`}
              className="mt-2 text-sm text-slate-600 font-mono-tech"
            >
              {COMPANY.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
